import {IntermediatePart} from "../../intermediatePart";
import {Toilet} from "../../parts/toilet";
import {removeLookPointFor} from "../../../lookNavigation/lookFunctions2";
import {getCurrentRoomType} from "../../../../appLayout";
import {LOOK_ROOM_TYPES} from "../../constants";

export default class PaperHolder extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'paper_holder';
    this.partName = 'Paper Holder';
    this.translateId = "visualizer.bathroom.accessories.paper_holder";
    this.canBeDisabled = true;
  }

  disabledClick() {
    const toiletParent = this.getParent().layout.parts[Toilet.id];
    if (toiletParent && toiletParent.toilet && toiletParent.toilet.disabled) {
      toiletParent.toilet.disabled = this.disabled || !toiletParent.toilet.canBeEnabled(); // true or check if it can be enabled;
    }
  }

  canDisplayDemoPoint(parentObject) {
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      return true
    }
    return removeLookPointFor(parentObject, 3, "2")
  }
}
